import { useState, useEffect } from "react";
import { AI_BASE_URL } from "../config/index";

// Load environment variable

const useHealthCheck = () => {
  const [isHealthy, setIsHealthy] = useState(null);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const response = await fetch(`${AI_BASE_URL}/healthcheck/`, {
          headers: {
            "Content-Type": "application/json",
          },
          method: "GET",
        });
        if (response.status === 200) {
          setIsHealthy(true);
        }
      } catch (error) {
        setIsHealthy(false);
      }
    };

    checkHealth();
  }, []);

  return isHealthy;
};

export default useHealthCheck;
